export type BuilderBindings = {
  x?: string[];
  y?: string[];
  series?: string;
  facet?: string;
  // Uncertainty visualization mode for error representation
  uncertainty?: 'CL' | 'SE' | 'SD';
  // Placement for N (sample size) labels
  n?: 'none' | 'subtitle' | 'tick' | 'text-annotation';
};

function normalizeChartName(chartId: string): string {
  // Accept ids or names; replace dashes/underscores with spaces
  const name = (chartId || '').trim().replace(/[-_]+/g, ' ');
  return name;
}

export function buildPrompt(chartId: string | null | undefined, bindings: BuilderBindings): string {
  const chartName = normalizeChartName(String(chartId || '').trim());
  const hasChart = chartName.length > 0;
  const parts: string[] = [];

  // Base pattern
  parts.push(`Create${hasChart ? ` a ${chartName}` : ''}`.trim());

  const xVals = Array.isArray(bindings.x) ? bindings.x.filter(Boolean) : [];
  const yVals = Array.isArray(bindings.y) ? bindings.y.filter(Boolean) : [];
  const series = (bindings.series || '').trim();
  const facet = (bindings.facet || '').trim();
  const uncertainty = (bindings.uncertainty || '').trim() as BuilderBindings['uncertainty'];
  const nMode = (bindings.n || 'none') as NonNullable<BuilderBindings['n']>;

  const extras: string[] = [];
  if (xVals.length > 0) {
    extras.push(`with X = ${xVals.join(', ')}`);
  }
  if (yVals.length > 0) {
    // Use single or multi form; both collapse to same wording with list
    if (extras.length > 0) {
      // append with delimiter: and Y =
      extras[extras.length - 1] = `${extras[extras.length - 1]}`; // keep previous as-is
    }
    extras.push(`and Y = ${yVals.join(', ')}`);
  }
  if (series) {
    extras.push(`series (or color) = ${series}`);
  }
  if (facet) {
    extras.push(`facet by ${facet}`);
  }

  if (uncertainty) {
    // Keep wording compact to fit the builder pattern
    extras.push(`uncertainty = ${uncertainty}`);
  }
  if (nMode && nMode !== 'none') {
    const nPhrase = nMode === 'subtitle'
      ? 'subtitle'
      : (nMode === 'tick' ? 'axis ticks' : 'text annotations overlay');
    extras.push(`N labels: ${nPhrase}`);
  }

  const suffix = extras.length > 0 ? ` ${extras.join(', ')}` : '';
  const text = `${parts.join('')}${suffix}`.trim();
  return text.endsWith('.') ? text : text;
}

export default buildPrompt;


